/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gift_Option_25_DescInputs */

const es_gift_option_25_desc = /** @type {(inputs: Gift_Option_25_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perfecto para quien aún no distingue babor de estribor.`)
};

const gl_gift_option_25_desc = /** @type {(inputs: Gift_Option_25_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perfecto para quen aínda non distingue babor de estribor.`)
};

const en_gift_option_25_desc = /** @type {(inputs: Gift_Option_25_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perfect for someone who still mixes up port and starboard.`)
};

/**
* | output |
* | --- |
* | "Perfect for someone who still mixes up port and starboard." |
*
* @param {Gift_Option_25_DescInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const gift_option_25_desc = /** @type {((inputs?: Gift_Option_25_DescInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gift_Option_25_DescInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_gift_option_25_desc(inputs)
	if (locale === "en") return en_gift_option_25_desc(inputs)
	return es_gift_option_25_desc(inputs)
});